export const MAX_LINE_ITEM_QUANTITY = 2147483647;